import { AnyAction } from "redux";
import axios from "../../lib/axios";
import {
  AccessRequestPayload,
  UpdateAccessPayload,
  User,
  UserDetail,
} from "../../types/auth.types";

export const GET_ACCESS_TOKEN = "GET_ACCESS_TOKEN";
export const GET_ACCESS_TOKEN_SUCCESS = "GET_ACCESS_TOKEN_SUCCESS";
export const GET_USER_DETAIL_SUCCESS = "GET_USER_DETAIL_SUCCESS";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const GET_USER_DETAILS_SUCCESS = "GET_USER_DETAILS_SUCCESS";
export const GET_USER_DETAILS_ERROR = "GET_USER_DETAILS_ERROR";
export const OPEN_ACCESS_REQUEST_MODAL = "OPEN_ACCESS_REQUEST_MODAL";
export const SEND_USER_REQUEST = "SEND_USER_REQUEST";
export const SEND_USER_REQUEST_SUCCESS = "SEND_USER_REQUEST_SUCCESS";
export const SEND_USER_REQUEST_ERROR = "SEND_USER_REQUEST_ERROR";
export const UPDATE_ACCESS = "UPDATE_ACCESS";
export const UPDATE_ACCESS_SUCCESS = "UPDATE_ACCESS_SUCCESS";
export const UPDATE_ACCESS_ERROR = "UPDATE_ACCESS_ERROR";

export interface IAuthReducer {
  isLoading: boolean;
  isLoggedIn: boolean;
  accessToken: string | null;
  user: User | null;
  isOpenAccessRequestModal: boolean;
  isLoadingUserDetails: boolean;
  userDetails: UserDetail[];
  isRequestingUserAccess: boolean;
  accessRequestError: string | null;
  isUpdatingUserAccess: string | null;
}

export const getAccessToken = () => ({
  type: GET_ACCESS_TOKEN,
});

export const gotAccessToken = (value: string) => ({
  type: GET_ACCESS_TOKEN_SUCCESS,
  value,
});

export const gotUserDetail = (value: User | null) => ({
  type: GET_USER_DETAIL_SUCCESS,
  value,
});

export const fetchUserDetails = (value = true) => ({
  type: GET_USER_DETAILS,
  value,
});

export const fetchUserDetailsSuccess = (value: UserDetail[]) => ({
  type: GET_USER_DETAILS_SUCCESS,
  value,
});

export const fetchUserDetailsError = () => ({
  type: GET_USER_DETAILS_ERROR,
});

export const openAccessRequestModal = (value: boolean) => ({
  type: OPEN_ACCESS_REQUEST_MODAL,
  value,
});

export const sendRequest = (
  insideRequestModal: boolean,
  data: AccessRequestPayload
) => ({
  type: SEND_USER_REQUEST,
  value: { insideRequestModal, data },
});

export const sendRequestSuccess = () => ({
  type: SEND_USER_REQUEST_SUCCESS,
});

export const sendRequestError = (value: string) => ({
  type: SEND_USER_REQUEST_ERROR,
  value,
});

export const updateAccess = (value: UpdateAccessPayload) => ({
  type: UPDATE_ACCESS,
  value,
});

export const updateAccessSuccess = () => ({
  type: UPDATE_ACCESS_SUCCESS,
});

export const updateAccessError = () => ({
  type: UPDATE_ACCESS_ERROR,
});

export const initialState: IAuthReducer = {
  isLoading: false,
  isLoggedIn: false,
  accessToken: null,
  user: null,
  isOpenAccessRequestModal: false,
  isLoadingUserDetails: false,
  userDetails: [],
  isRequestingUserAccess: false,
  accessRequestError: null,
  isUpdatingUserAccess: null,
};

export const authReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case GET_ACCESS_TOKEN:
      return {
        ...state,
        isLoading: true,
      };
    case GET_ACCESS_TOKEN_SUCCESS:
      const accessToken = action.value;
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      return {
        ...state,
        accessToken,
      };
    case GET_USER_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: true,
        user: action.value,
      };
    case GET_USER_DETAILS:
      return {
        ...state,
        isLoadingUserDetails: action.value,
      };
    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: action.value,
        isLoadingUserDetails: false,
      };
    case GET_USER_DETAILS_ERROR:
      return {
        ...state,
        userDetails: [],
        isLoadingUserDetails: false,
      };
    case OPEN_ACCESS_REQUEST_MODAL:
      return {
        ...state,
        isOpenAccessRequestModal: action.value,
      };
    case SEND_USER_REQUEST:
      return {
        ...state,
        isRequestingUserAccess: true,
        accessRequestError: null,
      };
    case SEND_USER_REQUEST_SUCCESS:
      return {
        ...state,
        isRequestingUserAccess: false,
        accessRequestError: null,
      };
    case SEND_USER_REQUEST_ERROR:
      return {
        ...state,
        isRequestingUserAccess: false,
        accessRequestError: action.value,
      };
    case UPDATE_ACCESS:
      return {
        ...state,
        isUpdatingUserAccess: action.value.id,
      };
    case UPDATE_ACCESS_SUCCESS:
      return {
        ...state,
        isUpdatingUserAccess: null,
      };
    case UPDATE_ACCESS_ERROR:
      return {
        ...state,
        isUpdatingUserAccess: null,
      };
    default:
      return state;
  }
};

export default authReducer;
